module.exports = __webpack_public_path__ + "static/media/church.29060d27.jpg";